class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form_action_url = routes.cart_add_url;
      this.submitButton = this.querySelector('[type="submit"]');
      this.clonedButton = this.querySelector('.product-form__submit--clone');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.productSection = this.closest('section.product-section');
      this.isModal = this.productSection?.classList.contains('product-section-quick-modal');
      this.cartIcon = document.querySelector('icon-cart');
      this.cartNotification = document.querySelector('#cart-notification');
      this.cartError = document.querySelector('#cart-error');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.enhancedDataLayer = document.querySelector('enhanced-datalayer');

      this.moreInfo = this.querySelector('[data-product-form-more-info]') && JSON.parse(this.querySelector('[data-product-form-more-info]').textContent);
      this.variantSelector = this.productSection.querySelector('variant-radios') || this.productSection.querySelector('variant-selects');
      this.variantInput = this.form.querySelector("input[name='id']");
      this.variants = [];
      if(this.variantSelector?.querySelector('[type="application/json"]')){
        this.variants = JSON.parse(this.variantSelector?.querySelector('[type="application/json"]')?.textContent);
      }

      this.VariantB2b = this.productSection.querySelector('variant-b2b');
      this.is_b2b = !!this.VariantB2b;
      if( this.is_b2b ){
        this.form_action_url = routes.cart_update_url;
      }

      this.mobileStickyWrapper = false;
    }
    
    connectedCallback(){
      /*Only on mobile - show "select a size" as label of add-to-cart button*/
      if(this.isMobile() && !this.isModal && !this.is_b2b) {
        if(this.variantInput.value) {
          this.submitButton.querySelector("span").innerHTML = window.variantStrings.addToCart;
        } else {
          this.submitButton.querySelector("span").innerHTML = window.variantStrings.selectSizeButtonLabel;
        }
      }

      if(!this.isModal){
        this.initMobileSticky();
        window.addEventListener("resize", this.initMobileSticky.bind(this));
      }
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.onSubmitHandler);
    }

    initMobileSticky(){
      if(!this.mobileStickyWrapper && window.matchMedia("(max-width: 749px)").matches && !this.isModal){
        this.mobileStickyWrapper = this.productSection.querySelector('.product-form__buttons--sticky');
        if(!this.mobileStickyWrapper) return;

        this.clonedButton.querySelector("span").innerHTML = this.submitButton.querySelector("span").innerHTML;
        this.notityClonedButton = this.mobileStickyWrapper?.querySelector('.product-form__notify--clone');

        document.addEventListener('scroll', this.mobileStickyDetector.bind(this));
        this.clonedButton.addEventListener('click', this.onSubmitHandler.bind(this));
        this.variantInput.addEventListener('change', function(e){
          var new_variant_id = e.target.value.toString();
          if(this.variants.find(v => v.id.toString() == new_variant_id &&  v.available)){
            this.clonedButton.querySelector("span").innerHTML = window.variantStrings.addToCart;
            this.clonedButton.classList.remove('hidden');
            this.notityClonedButton.classList.add('hidden');
          } else {
            this.clonedButton.querySelector("span").innerHTML = window.variantStrings.notifyMe;
            this.clonedButton.classList.add('hidden');
            this.notityClonedButton.classList.remove('hidden');
          }
        }.bind(this));

        this.notityClonedButton.addEventListener('click', function(){
          window.scrollTo({top: (this.variantSelector.getBoundingClientRect().top + window.pageYOffset + -100), behavior: 'smooth'});
        }.bind(this));

        this.mobileStickyWrapper.querySelector('.swym-button-dummy')?.addEventListener('click', function(){
          this.productSection.querySelector('.swym-button.swym-add-to-wishlist')?.click()
        }.bind(this));
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      // this.cartNotification.setActiveElement(document.activeElement);

      if(this.is_b2b){
        if(!this.VariantB2b.checkFormChangesB2b()){
          if(this.isModal){
            this.handleErrorMessage('No changes were made');
          }
          else{
            const event = new CustomEvent('click', {
              details: { target: this.cartError }
            });
            this.cartError.open(event);
            this.cartError.setMessage('No changes were made');
          }
            
          return false;
        }
      }

      this.lockSubmitButtons();

      let formBody = JSON.parse(serializeForm(this.form));

      if (this.is_b2b) {
        var b2bVariantData = this.VariantB2b.serializeInputs();
        formBody = Object.assign(formBody, b2bVariantData);
        delete formBody.id;
      }
      else if (formBody.id == "") {
        const event = new CustomEvent('click', {
          details: { target: this.cartError }
        });

        var cartErrorMessage = window.variantStrings.noSizePicked;
        if((document.querySelector("[name='is_gift_card']")?.value) == "true") {
          cartErrorMessage = window.variantStrings.noAmountPicked;
        }

        if(this.isModal){
          
        } else {
          if (this.variantSelector && this.isMobile()) {
            const variantSelectorOffset = this.variantSelector.getBoundingClientRect().top + window.pageYOffset + -100;
            window.scrollTo({top: variantSelectorOffset, behavior: 'smooth'});
          } else {
            this.cartError.open(event);
            this.cartError.setMessage(cartErrorMessage);
          }
        }
        
        this.handleErrorMessage(cartErrorMessage);
        this.unLockSubmitButtons();
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...formBody,
        // sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections: this.cartDrawer.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${this.form_action_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const event = new CustomEvent('click', {
              details: { target: this.cartError }
            });

            if(this.isModal){
            } else {
              this.cartError.open(event);
              this.cartError.setMessage(response.description);
            }
            
            this.handleErrorMessage(response.description);
            return;
          }

          const event = new CustomEvent('click', {
            details: { target: this.cartNotification }
          });

          var added_product_id = response.product_id ? response.product_id : window.product?.id;
          var added_product_handle = response.handle ? response.handle : window.product?.handle;
          if(this.isModal){
            /*success message above the button*/
            //this.cartNotificationModal(this.moreInfo?.cartSuccess);

            /*more styled element*/
            cartNotificationWithCrossSells();
            
          } else {
            /* PDP main form success */
            var temp__cartNotificationExtendedWrapper = document.querySelector("details-modal-product-quick");
            if(temp__cartNotificationExtendedWrapper && typeof added_product_id != "undefined"){
              /* success modal with cross-sell*/
              temp__cartNotificationExtendedWrapper.open(added_product_id, added_product_handle, "add-to-cart-success");
            }
            else {
              /* the Default success modal as backup */
              this.cartNotification.open(event);
            }

          }

          if(this.is_b2b){
            this.VariantB2b.updateDefaultQuantityValues();
          }

          // this.cartDrawer.setLastAddedTimestamp();
          // this.cartCountdown = document.querySelector('cart-countdown');
          // if (this.cartCountdown) {
          //   this.cartCountdown.restartClock();
          // }
          // this.enhancedDataLayer.onAddToCart(response);
          document.dispatchEvent(new Event('add_to_cart'));
          this.cartDrawer.renderContents(response, "add");
          // this.cartIcon.open();
          // this.cartNotification.renderContents(response);

          //tracking codes
            //response.id is the variant of the product
          
            //Graphene track - add to cart
            if(typeof $g != "undefined"){
              $g.track({
                scope           : "basket",
                action          : "add",
                data            : { product_id: added_product_id, quantity: 1 }
              });
            }
          //end tracking codes

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.unLockSubmitButtons();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessage.classList.remove("product-form__success-message");

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    lockSubmitButtons(){
      [this.submitButton, this.clonedButton].forEach(btn => {
        if(!btn) return;
        btn.setAttribute('aria-disabled', true);
        btn.classList.add('loading');
        btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      });
    }

    unLockSubmitButtons(){
      [this.submitButton, this.clonedButton].forEach(btn => {
        if(!btn) return;
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }

    cartNotificationModal(message = false){
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !message);

      if(message) {
        this.errorMessage.textContent = message;
        this.errorMessage.classList.add("product-form__success-message");
      } else {
        this.errorMessage.textContent = "";
        this.errorMessage.classList.remove("product-form__success-message");
      }
    }
    
    mobileStickyDetector(){
      var threshold = (this.form.getBoundingClientRect().top + window.scrollY);
      if(window.scrollY > threshold){
        this.mobileStickyWrapper.classList.add("sticky");
        document.body.classList.add('product-button--fixed');
      } else {
        this.mobileStickyWrapper.classList.remove("sticky");
        document.body.classList.remove('product-button--fixed');
      }
    }

    isMobile() {
      let check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}


class ColorPicker extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.productTitle = this.dataset.productTitle;
      this.productHandle = this.dataset.productHandle;

      this.colorSkus = [] && this.dataset.colors.split(',').filter(element => element);
      this.colorSkusBy10 = Shopify.arraySplitIntoChunksBySize(this.colorSkus, 10);
      this.searchCallIteration = 0;

      this.itemsWrapper = this.querySelector('.product-color-picker-row');
      this.items = this.itemsWrapper.querySelectorAll(':scope > .product-color-picker-item:not(.product-color-picker-item--all)');
      this.seeMore = this.querySelector('.product-color-picker-item--all');//todo use modal as from quick view or sizechart
      this.modalContent = this.querySelector('.modal__text');

      this.optionUnavailableProducts = this.dataset.unavailableProducts ? this.dataset.unavailableProducts : 'hide';
      this.items_per_media_lower_thresholds = {0:5, 750:6 , 1441: 7};

      /*let one be uncommented to switch between the used method*/  
      this.query_type = 'default_search'; //can search by multiple skus with OR, shows only available products
      //this.query_type = 'predictive_search'; //cannot search by multiple, choisable whether to show unavailable
    }

    connectedCallback(){
      window.addEventListener("resize", this.toggleSeeMore.bind(this));
      this.getItems();
      this.modalContent.append(this.items[0]?.cloneNode(true));
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.toggleSeeMore);
    }

    getItems(){
      if(!this.productTitle) return;
      
        if(this.query_type == 'default_search'){
          if(this.colorSkusBy10[this.searchCallIteration]){
            var url = new URL(`${window.location.origin}/search`);
            url.search = new URLSearchParams({
              q: Shopify.formatSkusForSearch(this.colorSkusBy10[this.searchCallIteration]).join(' OR '), /*search by sku*/
              //q: `title:${this.productTitle}`, /*search by title*/
              type: "product",
              view: `sku`
            }).toString();// + "&options[unavailable_products]=show";
console.log(354, this.searchCallIteration, this.colorSkusBy10[this.searchCallIteration], url);
            fetch(url).then(r => r.json()).then(r => {
              if(!r) return false;
              r.results.forEach(search_result_item => {
                this.renderItem(search_result_item);
              });

              this.searchCallIteration++;
              if(this.searchCallIteration < this.colorSkusBy10.length){
                this.getItems();
              } else {
                this.toggleSeeMore();
              }
            });
          }
        }
        else if(this.query_type == 'predictive_search'){
          var url = `${routes.predictive_search_url}.json?q=${encodeURIComponent(this.productTitle)}
&${encodeURIComponent('resources[type]')}=product
&${encodeURIComponent('resources[options][unavailable_products]')}=${this.optionUnavailableProducts}
&${encodeURIComponent('resources[options][fields]')}=title,variants.sku
&${encodeURIComponent('resources[options][prefix]')}=none
&${encodeURIComponent('resources[limit]')}=10`;

          fetch(url).then(r => r.json()).then(r => {
            if(!r) return false;
            r.resources.results.products.forEach(search_result_item => {
              this.renderItem(search_result_item);
            });
          
            this.toggleSeeMore();
          });
        }

    }

    renderItem(search_result_item){
      var new_item = this.items[0]?.cloneNode(true);
      if(!new_item) return;
      if(search_result_item.title != this.productTitle) return;

      var itemUrl = search_result_item.url?.split('?')?.at(0);
      if(this.query_type == 'default_search'){
        var itemHandle = itemUrl?.replaceAll('/products','').replace(/\\|\//g,'');
      } else {
        var itemHandle = search_result_item.handle;
      }
      var itemHandleToString = itemHandle?.replaceAll('-',' ');

      if(itemHandle == this.productHandle) return;

      new_item.classList.remove('selected', 'unavailable');
      new_item.setAttribute('href', itemUrl);
      new_item.setAttribute('title', itemHandleToString);
      new_item.querySelector('img').setAttribute('alt', itemHandleToString);
      new_item.querySelector('.media').classList.remove('media--transparent');

      if(!search_result_item.available && this.query_type == 'predictive_search'){
        new_item.classList.add('unavailable');
      }
      else if(this.query_type == 'default_search'){
        var temp_html = document.createElement('div');
        temp_html.innerHTML = search_result_item.cardHtml;
        if(temp_html.querySelector('product-card').dataset.productAvailable != "true"){/*initialy as string*/
          new_item.classList.add('unavailable');
        }
      }

      if(search_result_item.image && search_result_item.image.original){
        new_item.querySelector('img').setAttribute('src', search_result_item.image.original?.replace('_1000x','_100x'));
        new_item.querySelector('.media').classList.add('media--transparent');
      } else if(search_result_item.image){
        var extension_pos = search_result_item.image.lastIndexOf('.');
        var image_thumb = search_result_item.image.substring(0, extension_pos) + "_100x" + search_result_item.image.slice(extension_pos);
        new_item.querySelector('img').setAttribute('src', image_thumb);
        if(search_result_item.featured_image.alt.indexOf('|model') < 0){
          new_item.querySelector('.media').classList.add('media--transparent');
        }
      } else {
        new_item.querySelector('img').setAttribute('src', new_item.dataset.defaultImage);
      }

      this.seeMore.parentNode.insertBefore(new_item, this.seeMore);

      var new_item_in_see_more = new_item.cloneNode(true);
      var image_in_see_more = new_item_in_see_more.querySelector('img');
      image_in_see_more.setAttribute('src', image_in_see_more.getAttribute('src').replace('_100x','_260x'));
      this.modalContent.append(new_item_in_see_more);
    }

    toggleSeeMore(){
      this.items = this.itemsWrapper.querySelectorAll(':scope > .product-color-picker-item:not(.product-color-picker-item--all)');
      if(this.items.length > 1){
        this.classList.remove('hidden');
      }

      let items_per_media;
      Object.keys(this.items_per_media_lower_thresholds).forEach(lower_threshold => {
        if( window.matchMedia(`(min-width: ${lower_threshold}px)`).matches ){
          items_per_media = this.items_per_media_lower_thresholds[lower_threshold];
        }
      });

      if(this.items.length > items_per_media){
        this.itemsWrapper.classList.add('has-more');
      } else {
        this.itemsWrapper.classList.remove('has-more');
      }
    }
}

if (!customElements.get('color-picker')) {
  customElements.define('color-picker', ColorPicker);
}

function cartNotificationWithCrossSells(){
      const cartNotificationExtendedWrapper = document.querySelector("details-modal-product-quick");

      cartNotificationExtendedWrapper.querySelector('section.product-section').classList.add('after-add-to-cart');
      cartNotificationExtendedWrapper.querySelector('.product__info-wrapper').classList.add('hidden');
      cartNotificationExtendedWrapper.querySelector('.product__info-wrapper__after')?.classList.remove('hidden');
      cartNotificationExtendedWrapper.querySelector('.product__info-wrapper__after--short')?.classList.remove('hidden');

      var afterAddToCartCrossSell = cartNotificationExtendedWrapper.querySelector('.product__info-wrapper__after__cross-sell');
      if(afterAddToCartCrossSell){
        renderCrossSells(afterAddToCartCrossSell);
      }
}

function renderCrossSells(afterAddToCartCrossSell){
      if(!afterAddToCartCrossSell) return;
      var productHandle = afterAddToCartCrossSell.getAttribute('data-product-handle');
      var crossSellsType = afterAddToCartCrossSell.getAttribute('data-cross-sell-type');
      var url2call = false;
      if(!crossSellsType || crossSellsType == "none") return;

      if(crossSellsType == "cross-sell"){
        var url2call = `/products/${productHandle}?section_id=product-cross-selling--simple`;
      }
      else if(crossSellsType == "recommended"){
        var url2call = `/products/${productHandle}?section_id=product-variation`;
      }
      if(!url2call) return;

      fetch(url2call)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        afterAddToCartCrossSell.innerHTML = responseText;
      });
      
}
